import { render } from "./DynamicChip.vue?vue&type=template&id=cacb5dfa&ts=true"
import script from "./DynamicChip.vue?vue&type=script&lang=ts"
export * from "./DynamicChip.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"shared/src/entidades/builder/form/infrastructure/controls/editorTemplates/prime/DynamicChip.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "cacb5dfa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('cacb5dfa', __exports__)) {
    api.reload('cacb5dfa', __exports__)
  }
  
  module.hot.accept("./DynamicChip.vue?vue&type=template&id=cacb5dfa&ts=true", () => {
    api.rerender('cacb5dfa', render)
  })

}


export default __exports__